export enum BILLING_BILLING_ADDRESS_TAX_ID_STATUS {
  PENDING = 'pending',
  VERIFIED = 'verified',
  UNVERIFIED = 'unverified',
}
